//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import * as moment from "moment"

// custom pages
import { styles } from "./UploadCriteriaStatusStyles";
import Context from "context/context";

// material-ui
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

export default function UploadPromotionCriteriaStatus() {
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const history = useHistory();
  const classes = styles();

  let obj = {};
  if (location.state?.obj) {
    obj = location.state?.obj;
  } else {
    history.goBack();
  }
  const [states, setstates] = useState({});

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { } = states;

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "CRITERIA", "UPLOAD", "STATUS"],
    });
  }, []);

  const categoryLabels = {
    product_primary_class_id: "MPC",
    business_unit_code: "GL Cost Center",
    label_class_code: "Label Class Code",
    product_brand_name_code: "Brand",
    loyalty_category_code: "Sales Category",
    product_code: "Product Code",
    order_source_code: "Order Source Code",
    primary_major_class_code: "Primary Major Class Code",
    primary_submajor_class_code: "Primary Submajor Class Code",
    primary_minor_class_code: "Primary Minor Class Code",
    loyalty_id: "Loyalty Id",
    reason:"Reason",
    equipment_order_number:"Equipment Order Number",
    customer_account_number:"Shipto"
  };

  const handleFailedData = (header, data,data1,key) => {
    if (data1?.length > 0) {
 
      let t = [header,'Reason']
      let arr = data1?.map(str => [str[key]+String.fromCharCode(8203),str.reason])

    
      return [t, ...arr];
    }
    return [[]]
  }

  return (
    <div>
      <Button className={classes.backBtn} onClick={() => history.goBack()}>
        Back
      </Button>
      <Grid container spacing={0}>
        {obj &&
          Object.keys(obj).map((key) => (
            <Grid item xs={6} style={{ padding: "20px" }}>
              <div className={classes.categoryName}>{categoryLabels[key]}</div>
              <div className={classes.content1}>
                <div style={{ padding: "5px" }}> No of records uploaded :{" "}
                  <span style={{ color: "green", fontWeight: "bold" }}>
                    {obj?.[key]?.successCount ? obj?.[key]?.successCount : 0}
                  </span>
                </div>
                <div style={{ padding: "5px" }}>
                  No of invalid records :{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    {obj?.[key]?.failedCount ? obj?.[key]?.failedCount : 0}
                  </span>
                </div>
                {obj?.[key]?.failedData && <Button className={classes.exportBtn} onClick={() => { document.getElementById(`${key}`).click() }}>Export</Button>}
                <CSVLink
                  id={`${key}`}
                  data = {
                    handleFailedData(categoryLabels[key], obj?.[key]?.failedData,obj?.[key]?.reason,key)}
                   
                  filename={
                    categoryLabels[key] +
                    " " +
                    moment(new Date()).format("MM-DD-YYYY,h:mm A") +
                    ".csv"
                  }
                  className={classes.CSVlink}
                />
              </div>
            </Grid>
          ))}
      </Grid>
    </div>
  );
}
